module.exports = __webpack_public_path__ + "img/google-play-badge.cfca9a05.svg";